import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AnswerPage2.scss';

const quizData2 = [
	{
		no: 1,
		type: 1,
		title: '놀이기구 타며 손들고 인사하는 판다는 누구일까요?',
		picture: '/assets/2-1.webp',
		button1: '루이바오',
		button2: '후이바오',
		answer: '1',
		explanation:
			'이 사진에서 루이와 후이를 구분하는 방법은 외모에요.\n' +
			'귀사이 정수리 넓이 : 루이는 짧고 뾰족한 느낌, 후이는 넓고 둥근 느낌이에요.\n' +
			'콧잔등 가마 :  루이는 2개, 후이는 1개에요!\n' +
			'눈 흰자 : 바오패밀리는 안구에 검은점이 있는게 특징이에요! 루이가 유일하게 점이 없어서 가끔 흰자가 보일때면 눈을 희번덕하게 뜬 느낌이에요!',
	},
	{
		no: 2,
		type: 1,
		title: '엄마와 나란히 누워있는 바오들 중 후이를 찾아주세요.',
		picture: '/assets/2-2a.webp',
		button1: '왼쪽',
		button2: '오른쪽',
		answer: '2',
		explanation:
			'이 사진에서 루이와 후이를 구분하는 방법은 등의 볼레로와 몸매에요. 루이는 넓고 깊은 볼레로를 가지고 있고 후이는 좁고 짧은 볼레로를 가지고 있어요. 몸매는 루이에 비해 후이가 둔둔하고 통통한 편이에요~',
	},
	{
		no: 3,
		type: 1,
		title: '앞서서 나무를 오르는 판다는 누구일까요?',
		picture: '/assets/2-3.gif',
		button1: '루이바오',
		button2: '후이바오',
		answer: '1',
		explanation:
			'영상속의 루이바오와 후이바오를 관찰해보세요~!\n' +
			'앞서 올라가는 짧은 다리 판다의 볼레로 모양을 보시면 맞추실 수 있을거에요!',
	},
	{
		no: 4,
		type: 1,
		title: '나무에서 떨어진 바오들, 어느쪽이 루이일까요?',
		picture: '/assets/2-4.webp',
		button1: '왼쪽',
		button2: '오른쪽',
		answer: '2',
		explanation:
			'어부바 나무에서 떨어지는 우당탕 바오자매들~  생김새를 관찰하면 누가 루이인지 알아맞출 수 있어요! 턱에 아이바오처럼 검은 털이 있어서 투턱으로 보인다면 그 판다는 후이바오! 콧잔등 가마를 봐도 알 수 있어요!',
	},
	{
		no: 5,
		type: 1,
		title: '비누방울 불고 있는 판다는 누구일까요?',
		picture: '/assets/2-5a.webp',
		button1: '루이바오',
		button2: '후이바오',
		answer: '2',
		explanation:
			'짱구 옆태를 똑 닮은 그 판다! 여유롭게 비누방울을 불고 있네요~\n' +
			'루이 후이를 털로 비교해본다면 루이는 약간 곱슬이고 후이는 아빠를 닮아 직모라고 해요!',
	},
	{
		no: 6,
		type: 1,
		title: '나무에 올라가서 휴식을 취하는 판다는 누구일까요?',
		picture: '/assets/2-6a.webp',
		button1: '루이바오',
		button2: '후이바오',
		answer: '2',
		explanation:
			'루이바오와 후이바오는 꼬리 모양으로 비교할 수 있어요. 루이바오는 꼬리가 길고 후이바오는 꼬리가 짧고 털이 풍성한 편이에요.',
	},
	{
		no: 7,
		type: 1,
		title: '사육사 앞에 서있는 판다는 누구일까요?',
		picture: '/assets/2-7.gif',
		button1: '루이바오',
		button2: '후이바오',
		answer: '1',
		explanation:
			'야생의 맹수미를 뽐내는 이 판다는 생김새로 알아볼 수 있죠?\n' +
			'등의 볼레로 모양과 누룽누룽한 노란빛 털로 루이바오를 알아볼 수 있어요!',
	},
	{
		no: 8,
		type: 1,
		title: '뱃살스키를 타는 이 판다는 누구일까요?',
		picture: '/assets/2-8.gif',
		button1: '루이바오',
		button2: '후이바오',
		answer: '2',
		explanation:
			'잘 웃는 루이바오는 햇살이, 뱃살이 통통한 후이바오는 뱃살이 라는 별명이 있어요~ 이 영상은 [오와둥둥] 유투브에 나온 후이바오가 뱃살로 스키를 타는 재미있는 장면이에요',
	},
	{
		no: 9,
		type: 1,
		title: '야무지게 문열고 들어가는 이 판다는 누구일까요?',
		picture: '/assets/2-9.gif',
		button1: '루이바오',
		button2: '후이바오',
		answer: '1',
		explanation:
			'영상에 나오는 똑똑 이 판다는 볼레로를 보고 맞혀 보세요~! 참고로 루이와 후이 중에 다리가 길고 잘 웃는 판다입니다~!',
	},
	{
		no: 10,
		type: 1,
		title: '이 발바닥은 누구의 것일까요?',
		picture: '/assets/2-10.webp',
		button1: '루이바오',
		button2: '후이바오',
		answer: '2',
		explanation:
			'루이바오와 후이바오 영상을 꾸준히 열심히 본 임오, 삼툔들이 알 수 있는 발바닥이에요~ 후이바오 어릴 적에, 송바오가 후이바오 발바닥을 보며 영상 속에서 소원(?)을 빌었는데, 후이바오가 커서 그 소원을 실제로 이뤄주어 효녀 판다라는 말을 듣고 있죠 :)',
	},
];

const AnswerPage2 = () => {
	const navigate = useNavigate();
	const handleStartClick2 = () => {
		navigate('/v2');
		window.scrollTo(0, 0); // /quiz 경로로 이동
	};
	const handleBackClick = () => {
		navigate(-1);
		window.scrollTo(0, 0); // 이전 페이지로 이동
	};

	return (
		<div className="answer-container">
			<div className="alert2">
				<div><p className="alerts">
					2탄에는 1탄을 마스터해야 풀 수 있는 문제가 있습니다. 아직 1탄을 해보지
					않으셨다면, 1탄 먼저 완료하고 오세요!
				</p>
					<p>
						※ 사진 각도에 따라 구분법이 조금 다를 수 있어요!
					</p></div>
			</div>
			{quizData2.map((quiz, index) => (
				<div key={index} className="answer-item">
					<div className="answer-head">
						<div className="answer-head-info">
							<div className="answer-head-info-num2">Q.{quiz.no}</div>
							<h3 className="answer-head-title">{quiz.title}</h3>
						</div>
					</div>
					<div className="answer-content2"><img src={quiz.picture} alt={`Quiz ${quiz.no}`} className="answer-image" onLoad={(e) => {
						e.target.style.display = 'block';
					}}/></div>
					<div className="answer-explanation">
						<div className="answer-explanation-title">✍🏻 해설</div>

						<div className="answer-explanation-detail">{quiz.explanation}</div>
					</div>
				</div>
			))}
			<div className="button-wrapper">
				{' '}
				<button className="result-button2" onClick={handleStartClick2}>
					테스트 다시하기
				</button>
				<button className="back-button" onClick={handleBackClick}>
					뒤로가기
				</button>
			</div>
		</div>
	);
};

export default AnswerPage2;
